import {
    DINE_IN_ID,
    SALE_MODE_LABEL_BY_ID,
    TAKE_AWAY_ID,
} from "@constants/index";
import { toast } from "react-toastify";

export const API_LOCATION_MANAGEMENT = "/settings/general/locationManagement";
export const API_SALE_MODE = "/settings/general/sale_mode";
export const API_CC_DOMAINE = "/settings/list/c&c/domaine";

export const enableCheckbox = () => {
    let checks = document.getElementsByClassName("PrivateSwitchBase-root");
    for (let i = 0; i < checks.length; i++) {
        checks[i].classList.remove("not-allowed-icon__clz");
    }
};

export const disableCheckbox = () => {
    let checks = document.getElementsByClassName("PrivateSwitchBase-root");
    for (let i = 0; i < checks.length; i++) {
        checks[i].classList.add("not-allowed-icon__clz");
    }
};

export async function getModeOfSales(
    userID: number,
    franchiseID: string,
    shopId: string,
    i18nextLng: string,
    setModeOfSales: Function,
    fetchGlobal: <T>(url: string, options?: RequestInit) => Promise<T>
) {
    const newList: any[] = [];
    try {
        const result: any = await fetchGlobal(
            `${process.env.REACT_APP_API_V2_URL}${API_SALE_MODE}?franchiseId=${franchiseID}&shopId=${shopId}`,
            {
                headers: {
                    "Content-Type": "application/json",
                    "Accept-Language": i18nextLng,
                },

                method: "GET",
            }
        );

        for (let element of result.data) {
            if (element === DINE_IN_ID || element === TAKE_AWAY_ID) {
                const label = SALE_MODE_LABEL_BY_ID[element];
                if (!label) continue;
                newList.push({
                    label,
                    value: element,
                });
            }
        }
        setModeOfSales(newList);
    } catch (error) {
        console.log("there is an error");
    }
}

export async function getSite(
    t: any,
    dataLocation: any,
    setQrData: Function,
    schema: any,
    franchiseID: any,
    i18nextLng: any,
    shopId: any,
    fetchGlobal: <T>(url: string, options?: RequestInit) => Promise<T>
): Promise<string | undefined> {
    try {
        const url = `${process.env.REACT_APP_API_V2_URL}${API_CC_DOMAINE}?schema=${schema}&shopId=${shopId}`;

        const result: any = await fetchGlobal(url, {
            method: "GET",
            headers: {
                "Content-Type": "application/json",
                "Accept-Language": i18nextLng,
            },
        });

        const domaine = result?.data?.[0]?.domaine;

        let formattedDomaine =
            domaine !== undefined
                ? domaine.startsWith("https")
                    ? domaine
                    : `https://${domaine}`
                : "";

        const shopData = result?.data?.[0];

        const finalUrl =
            shopData && shopData["Web site"] > 0
                ? `${formattedDomaine}?place=${encodeURIComponent(
                      dataLocation[t("Designation")]
                  )}&id1=${franchiseID}&id2=${shopId}&${
                      dataLocation.modeOfSale === null
                          ? ""
                          : "id3=" + dataLocation.modeOfSale.value
                  }`
                : `noSite?place=${encodeURIComponent(
                      dataLocation[t("Designation")]
                  )}&id1=${franchiseID}&id2=${shopId}&${
                      dataLocation.modeOfSale === null
                          ? ""
                          : "id3=" + dataLocation.modeOfSale.value
                  }`;

        setQrData(finalUrl);

        return finalUrl;
    } catch (error) {
        console.error("getSite error:");
        return undefined;
    }
}

export const copyUrl = (qrData: any, t: any) => {
    navigator.clipboard.writeText(qrData);
    toast.dismiss();
    toast.success(`${t("The QR code URL has been successfully copied")}`, {
        position: toast.POSITION.TOP_CENTER,
        theme: "colored",
    });
};
export const downloadQRCode = (id: string, qrCodeRefs: any, t: any) => {
    const qrContainer = qrCodeRefs.current[id];
    if (!qrContainer) return;
    const canvas = qrContainer.querySelector("canvas");
    if (!canvas) return;
    const image = canvas.toDataURL("image/png");
    const anchor = document.createElement("a");
    anchor.href = image;
    anchor.download = `qr-code-${id}.png`;
    document.body.appendChild(anchor);
    anchor.click();
    document.body.removeChild(anchor);
    toast.dismiss();
    toast.success(`${t("The QR code has been successfully downloaded.")}`, {
        position: toast.POSITION.TOP_CENTER,
        theme: "colored",
    });
};
